document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("oteka-popup");

  if (!popup) return;

  const storageKey = "oteka_popup_hidden_until";
  const formSuccess = popup.dataset.success === "true";
  const delay = 8000;
  const thirtyDays = 30 * 24 * 60 * 60 * 1000;

  const getHiddenUntil = () => {
    try {
      return Number(localStorage.getItem(storageKey) || 0);
    } catch (error) {
      return 0;
    }
  };

  const rememberForThirtyDays = () => {
    try {
      localStorage.setItem(
        storageKey,
        String(Date.now() + thirtyDays)
      );
    } catch (error) {
      console.warn("Stockage local indisponible.");
    }
  };

  const openPopup = () => {
    popup.classList.add("is-visible");
    popup.setAttribute("aria-hidden", "false");
    document.body.classList.add("oteka-popup-open");

    const firstInput = popup.querySelector(
      'input:not([type="hidden"])'
    );

    window.setTimeout(() => {
      firstInput?.focus();
    }, 350);
  };

  const closePopup = (remember = true) => {
    popup.classList.remove("is-visible");
    popup.setAttribute("aria-hidden", "true");
    document.body.classList.remove("oteka-popup-open");

    if (remember) {
      rememberForThirtyDays();
    }
  };

  popup.querySelectorAll("[data-oteka-close]").forEach((button) => {
    button.addEventListener("click", () => closePopup(true));
  });

  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Escape" &&
      popup.classList.contains("is-visible")
    ) {
      closePopup(true);
    }
  });

  const copyButton = popup.querySelector("[data-copy-code]");
  const copyMessage = popup.querySelector("[data-copy-message]");
  const codeElement = document.getElementById(
    "oteka-discount-code"
  );

  copyButton?.addEventListener("click", async () => {
    const code = codeElement?.textContent?.trim() || "DECOUVERTE";

    try {
      await navigator.clipboard.writeText(code);
      copyButton.textContent = "Copié !";

      if (copyMessage) {
        copyMessage.hidden = false;
      }

      window.setTimeout(() => {
        copyButton.textContent = "Copier";

        if (copyMessage) {
          copyMessage.hidden = true;
        }
      }, 2500);
    } catch (error) {
      window.prompt("Copiez votre code :", code);
    }
  });

  if (formSuccess) {
    openPopup();
    rememberForThirtyDays();
    return;
  }

  if (Date.now() < getHiddenUntil()) {
    return;
  }

  window.setTimeout(openPopup, delay);
});